@if (externalDashboards.length > 0) {
    <adapt-dashboard-element name="External links">
        @for (dashboard of externalDashboards; track dashboard) {
            <div>
                @if (dashboard.dashboard.openInNewTab) {
                    <a [attr.href]="dashboard.dashboard.url"
                       target="_blank"
                       rel="noreferrer noopener">
                        <i class="fal fa-fw fa-sm fa-external-link-alt"></i>
                        {{ dashboard.dashboard.name }}
                    </a>
                } @else {
                    <a [routerLink]="dashboard.url.path"
                       [queryParams]="dashboard.url.queryParams">
                        <i class="fal fa-fw fa-sm fa-browsers"></i>
                        {{ dashboard.dashboard.name }}
                    </a>
                }
            </div>
        }
    </adapt-dashboard-element>
}
